import { css } from '@emotion/react';
import { FunctionComponent } from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { IconButton } from '../button/icon-button';
import { Icon, IconProps } from '../icon';

export interface InputClearIconShellProps {
  onClick: (e: any) => void;
  color?: IconProps['color'];
  width?: number;
  height?: number;
}

export const InputClearIconShell: FunctionComponent<InputClearIconShellProps> = ({
  onClick,
  color,
  width,
  height,
}) => {
  const { tICU } = useTranslations();
  return (
    <div css={styles.buttonStyle}>
      <IconButton
        aria-label={tICU('widget.CLEAR_BUTTON')}
        tappableAreaSize={'24px'}
        onClick={onClick}
        type="button"
      >
        <Icon type="clear" color={color} width={width} height={height} />
      </IconButton>
    </div>
  );
};

const styles = {
  buttonStyle: css({
    padding: 0,
    background: 'none',
    border: 'none',
  }),
};
